import React from "react";

export const DoubleLine = ({ title, text,
                               fontColor='',
                               maxLength = 40,
                               titleSize='14px',
                               textSize='12px',
                               titleWeight='600',
                               textWeight='400',
                               noGap=false
}) => {
    // Utility function to truncate text based on maxLength
    let truncateText = (_text) => {
        // Check if text needs to be truncated
        if (_text?.length > maxLength) {
            return `${_text?.substring?.(0, maxLength)}..`; // Truncate and append ellipsis
        }
        return _text; // Return original text if no truncation is needed
    };
    const titleStyle = {
        fontSize: titleSize,
        fontWeight: titleWeight,
        color: fontColor

    }
    const textStyle = {
        fontSize: textSize,
        fontWeight: textWeight,
        color: fontColor,
    }
    let containerStyle = {
        display: 'flex',
        flexDirection: 'column'
    }
    if (noGap){
        containerStyle.lineHeight = '1';
    }
    return (
        <div style={containerStyle}>
            <span style={titleStyle}>{truncateText(title)}</span>
            <span style={textStyle}>{truncateText(text)}</span>
        </div>
    );
}
